import { IMAGE_LOADER, ImageLoaderConfig } from '@angular/common';
import { Provider } from '@angular/core';
import { RouteReuseStrategy, TitleStrategy } from '@angular/router';
import { PageTitleStrategy } from '@core/strategies/page-title.strategy';
import CustomRouterReuseStrategy from '@core/strategies/router-reuse.strategy';
import { environment } from '@env/environment';
import { UniversalDeviceDetectorService } from '@services/universal-device-detector.service';
import { DeviceDetectorService } from 'ngx-device-detector';

/**
 * provide image loader: load image from cdn with width param
 *
 * @export
 * @return {*}  {Provider}
 */
export function provideImageLoader(): Provider {
    return {
        provide: IMAGE_LOADER,
        useValue: ({ src, width: cfWidth }: ImageLoaderConfig) => {
            const cdn = environment.cdn;
            if (!src.startsWith(cdn)) {
                return src;
            }
            const width = cfWidth ?? 500;
            const isCdnUrlEndsWithSlash = cdn.endsWith('/');
            const cdnUrl = isCdnUrlEndsWithSlash ? cdn : `${cdn}/`;
            const paths = src.replace(cdnUrl, '').split('/');

            // if the image url not contains width param, add width param to the url
            if (paths.length === 1) {
                paths.unshift(width.toString());
            }
            return cdnUrl.concat(paths.join('/'));
        },
    };
}

/**
 * Provide Universal Device Detector
 *
 * @export
 * @return {*}  {Provider}
 */
export function provideUniversalDeviceDetector(): Provider {
    return {
        provide: DeviceDetectorService,
        useClass: UniversalDeviceDetectorService,
    };
}

/**
 * Provide Title Strategy
 *
 * @export
 * @return {*}  {Provider}
 */
export function provideTitleStrategy(): Provider {
    return { provide: TitleStrategy, useClass: PageTitleStrategy };
}

/**
 * Provide Router Reuse Strategy
 *
 * @export
 * @return {*}  {Provider}
 */
export function provideRouterReuseStrategy(): Provider {
    return { provide: RouteReuseStrategy, useClass: CustomRouterReuseStrategy };
}
